/**
 * Handle big device
 */
export enum BIGDevice {
  Unknown = -1,
  Q896S = 1, //OLD touch 7 inches
  Q898X = 2, //OLD touch 10 inches
  Q5 = 3, // touch 5 inches
  Q8919 = 4, //OLD touch 10 inches
  Q7S = 6, //NEW touch 7 inches
  Q133S = 7 //NEW touch 10 inches (Android 13)
}

/**
 * Hande generic device addresses
 */
export enum BIGDeviceAddress {
  LED_COLOR = 1,
  RELAY_1_PERMANENT_ON_OFF = 2,
  RELAY_2_PERMANENT_ON_OFF = 3,

  RELAY_1_STAIRCASE_ON = 4,
  RELAY_2_STAIRCASE_ON = 5,

  RELAY_1_ON_DELAY = 6,
  RELAY_1_OFF_DELAY = 7,

  RELAY_2_ON_DELAY = 8,
  RELAY_2_OFF_DELAY = 9,

  INPUT_1_BIT = 10,
  //INPUT_1_VALUE = 11, /** Removed from DB in ticket BIG3-4986 */
  INPUT_1_DISABLE = 12,

  INPUT_2_BIT = 13,
  //INPUT_2_VALUE = 14, /** Removed from DB in ticket BIG3-4986 */
  INPUT_2_DISABLE = 15,

  OPERATING_MODE = 16,
  DEVICE_DESCRIPTOR = 17,

  REBOOT_DEVICE = 18,

  DISPLAY_BRIGHTNESS = 19
}

/**
 * Handle big input device contact primary function
 */
export enum BIGDeviceInputFunction {
  EDGE = 1,
}

/**
 * Handle big input type contact
 */
export enum BIGDeviceInputContactType {
  BREAK_CONTACT = 1,
  MAKE_CONTACT = 2,
}

/**
 * Handle big input type value to send
 */
export enum BIGDeviceValueType {
  ON_OFF = 1,
  NUMBER_VALUE = 2,
}

/**
 * Handle big device type for myto reader.
 * NOTE: Each of these types corresponds to a specific, general way to manage the reading/writing of the card. Therefore, 
 * multiple possible cards (each assigned to a environment with a different manufacturerSystem) can fall under a single "BIGDeviceType".
 */
export enum BIGDeviceType {
  VIMAR_WELL_CONTACT_PLUS = 0,  //SPECIFICALLY, for MIFARE-tehchnology cards (DESFIRE-technology cards are NOT supported for NOW)
  ABB_MILLENIUM = 1,
  BIG_MIFARE = 2,
  BLUMOTIX_2025 = 3,
  CIE = 4,  //virtual reader for the Italian electronic identity card: the credential is the NIS, read through an external reader (matches the DEVICE_TYPE of the CIE record in the server device catalog)
}

/**
 * Handle big input effective value to send
 */
export enum BIGDeviceValueToSend {
  NONE = 0,
  TOGGLE = 1,
  SEND_0 = 2,
  SEND_1 = 3,
  SEND_VALUE = 10,
}

/**
 * Handle big type of reading
 */
export enum BIGModeReading {
  UID = 1,
  CARD_NUMBER = 0,
}

/**
 * Handle the various operation modes in which the app can be working;
 */
export enum BIGDeviceOperationMode {
  /**Default mode;  the app assumes constant contact with API server and MQTT broker*/
  STANDARD = 0,
  /**"Lightweight", "stand alone" mode; the app DOES NOT assume costant contact with API server.
   *
   * IN THIS MODE, SPECIAL MEASURES ARE TAKEN TO ASSURES
   * the "ACCESS CONTROL" FEATURE IS WORKING, EXPECIALLY FOR PASSAGES DIRECTLY CONTROLLED BY "MYTO" INTEGRATED RELAYES.
   */
  ACCESS_CONTROL_MODE = 1,

  /**
   * This mode is developed expecially where app is intended to work as "Digital Place" client. This mode features:
   *  +  No polling to APi server.
   */
  DIGITAL_PLACE_MODE = 2,
}

/**
 * Define all the existing relays integrated into the device
 *
 * (IN THIS CASE: Q896S "MYTO" touch)
 */
export enum BIGDeviceRelaysQ896S {
  NO_RELAY = 0,
  RELAY_1 = 1,
  RELAY_2 = 2,
}

/**
 * Define all the possible kind of operations which can be execute on a relay
 */
export enum BIGDeviceRelayOperationKind {
  OPEN = 0,
  CLOSE = 1,
}
